import { render, staticRenderFns } from "./ProduccionUsuario.vue?vue&type=template&id=074c2358&"
import script from "./ProduccionUsuario.vue?vue&type=script&lang=js&"
export * from "./ProduccionUsuario.vue?vue&type=script&lang=js&"
import style0 from "./ProduccionUsuario.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports